export default {"src":"/_next/static/media/experiencedBadge.aabcac72.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};